import { formatTimestampHuman } from "../date-utils";
export const contactCompanyDtoFields = [{
        name: "companyName",
        title: "Organizzazione",
        render: (record) => `<a href="/company/${record.companyId}">${record.companyName}</a>`
    }, {
        name: "mainCompany",
        title: "Organizzazione Principale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.companyContact.mainCompany === 1 ? "check" : "close"}</i>`
    }, {
        name: "clfJobPositionId",
        title: "Carica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.contactPosition == null ? "" : record.contactPosition
    }, {
        name: "clfJobRoleId",
        title: "Ruolo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.contactRole == null ? "" : record.contactRole
    }, {
        name: "updatedBy",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        title: "Ultima Modifica"
    }, {
        name: "updatedOn",
        title: "Data Modifica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.updatedOn)
    }];
